import React from 'react'
import { Link } from 'react-router-dom'
import '../../main-component/Landing/landing.css';



const ClickHandler = () => {
    window.scrollTo(10, 0);
}


const Footer = (props) => {

    return (
        <footer className="wpo-site-footer">
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="widget-title">
                                    <h2>
                                        La tecnologia più avanzata per il benessere del tuo gatto.
                                    </h2>
                                </div>
                                <div className="social-widget">
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="#"><i className="ti-facebook"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="ti-twitter-alt"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="ti-linkedin"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="ti-instagram"></i></Link></li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget contact-widget">
                                <div className="widget-title">
                                    <h3>Contatti</h3>
                                </div>

                                <ul>
                                    <li>dtmacchine@gmail.com</li>
                                    <li>+39 348 722 6077</li>
                                    <li>Via Contrada Posta Cisterna, Snc <br /> Castelluccio dei Sauri (FG) 71025 </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Links</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="/kleeo/la-rivoluzione-pulita">Kleeo</Link></li>
                                    <li><Link onClick={ClickHandler} to="/faq">Faq</Link></li>
                                    <li><Link onClick={ClickHandler} to="/shop">Shop</Link></li>
                                    <li><Link onClick={ClickHandler} to="/blog">News</Link></li>
                                    <li><Link onClick={ClickHandler} to="/contact">Contattaci</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container-fluid">
                    <div className="row g-0">
                        <div className="col col-lg-6 col-12">
                            <p className="copyright"> Copyright &copy; 2026 DTM di Turchiarelli Danilo Francesco — P.IVA 04456570714
                               <br/> Tutti i diritti riservati.
                            </p>
                        </div>
                        <div className="col col-lg-6 col-12">
                            <ul className="right">
                                <li><Link onClick={ClickHandler} to="/privace"><span className="rolling-text">Privacy & Policy</span> </Link></li>
                                <li><Link onClick={ClickHandler} to="/terms"><span className="rolling-text">Termini</span></Link></li>
                                <li><Link onClick={ClickHandler} to="/come-funziona"><span className="rolling-text">Kleeo</span></Link></li>
                                <li><Link onClick={ClickHandler} to="/faq"><span className="rolling-text">FAQ</span></Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;







